export default __webpack_public_path__ + "static/media/OpenSans-Medium.5b0a682f.ttf";